// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/**
 * Rust's string handling where the portal must give the backend's answer
 * (the voter's channel, a masked destination). JavaScript's `trim` and
 * `toUpperCase` differ from Rust's: `trim` also drops U+FEFF but keeps U+0085,
 * and `toUpperCase` maps `ſ` to `S`.
 */
/** `char::is_whitespace`: the Unicode White_Space property. */
var RUST_WHITESPACE = "\t\n\v\f\r \u0085   -     　";
var LEADING = new RegExp("^[".concat(RUST_WHITESPACE, "]+"));
var TRAILING = new RegExp("[".concat(RUST_WHITESPACE, "]+$"));
var ANY = new RegExp("[".concat(RUST_WHITESPACE, "]"));
/** `str::trim`. */
export var rustTrim = function (value) { return value.replace(LEADING, "").replace(TRAILING, ""); };
/** Whether the text has a character `char::is_whitespace` holds. */
export var hasRustWhitespace = function (value) { return ANY.test(value); };
/** `str::to_ascii_uppercase`: a–z only. */
export var toAsciiUppercase = function (value) {
    return value.replace(/[a-z]/g, function (letter) { return letter.toUpperCase(); });
};
